import { useCallback } from 'react';
import { StripeAddressElementChangeEvent } from '@stripe/stripe-js';
import { AddressElementProps } from '@stripe/react-stripe-js';

import { PURCHASE_ALLOWED_COUNTRIES } from '@web/account/constants';
import getSubscriptionCycleOptions from '@web/account/utils/getSubscriptionCycleOptions';
import { usePurchaseContext } from '@web/account/purchase/PurchaseProvider/PurchaseProvider';
import { mapFormValuesToBillingAddress } from '@web/account/utils/mappers';

import { Props } from './PaymentCycleAndMethod';

export const usePaymentCycleAndMethod = ({
  currency,
  monthlyPricePerUserPerMonth,
  yearlyPricePerUserPerMonth,
  yearlyPlanDiscount,
}: Props) => {
  const { setBillingAddress } = usePurchaseContext();
  const subscriptionCycles = getSubscriptionCycleOptions({
    currency,
    monthlyPricePerUserPerMonth,
    yearlyPricePerUserPerMonth,
    yearlyPlanDiscount,
  });

  const onAddressChange = useCallback(
    (event: StripeAddressElementChangeEvent) => {
      if (event.complete) {
        const billingAddress = mapFormValuesToBillingAddress(event.value);

        setBillingAddress(billingAddress);
      }
    },
    [setBillingAddress]
  );

  const billingAddressProps: AddressElementProps = {
    options: { mode: 'billing', allowedCountries: PURCHASE_ALLOWED_COUNTRIES },
  };

  return {
    billingAddressProps,
    subscriptionCycles,
    onAddressChange,
  };
};
